export default "__VITE_PUBLIC_ASSET__385aa25a__"